import React from 'react';
import classNames from 'classnames';
import bn from '../utils/bemnames';

const bem = bn.create('filter-btn');

interface IProps {
  filterKey: any;
  activeKey: any;
  checkMark?: boolean;
  onClick?: (value: any) => void;
  clickOnActive?: boolean;
  children: any;
}

const FilterBtn = React.forwardRef<HTMLButtonElement, IProps>(({ filterKey, activeKey, checkMark, onClick, clickOnActive, children }, ref) => {
  const active = (filterKey === activeKey);

  return (
    <button
      ref={ref}
      className={classNames({
        [bem.b()]: true,
        [bem.e('active')]: active,
      })}
      style={{
        cursor: (active && !clickOnActive) ? 'default' : '',
      }}
      type="button"
      onClick={onClick && (!active || clickOnActive) ? () => { onClick(filterKey) } : undefined}
    >
      {active && checkMark && (
        <span className={bem.e('check-mark')}>✔</span>
      )}
      {children}
    </button>
  );
});

export default FilterBtn;
